export default __webpack_public_path__ + "static/media/bathroom2-afterA-2048w.a4cbf8e3.avif";